<template>
  <a
    v-if="showAnnouncement && !isAdventCalendar"
    :href="announcement.urlToRoute"
    target="_blank"
    class="r-box relative cursor-pointer clickable-element text-24 m-auto block"
    :style="setBackgroundImage()"
  ></a>
  <div
    v-else-if="showAnnouncement && isAdventCalendar"
    class="r-box relative cursor-pointer clickable-element text-24 m-auto block announcement-advent"
    :style="setBackgroundImage()"
    @click="goToAdvent"
  >
    <div
      class="r-box-text w-full absolute text-texts-standard-default flexing justify-start uppercase"
    >
      <shrink-text :text="$t('event.advent_calendar')" :font-size="24" />
    </div>
    <vue-countdown
      v-if="timer"
      v-slot="{ days, hours, minutes, seconds }"
      class="r-box-time flexing text-texts-standard-default italic absolute bottom-0"
      :time="timer"
      @end="reloadAnnouncements"
    >
      <app-icon icon-name="time" class="r-box-time-icon inline mr-2" />
      {{ timer ? formatTime(days, hours, minutes, seconds) : '' }}
    </vue-countdown>
  </div>
</template>

<script lang="ts">
import { pathImages } from '@/globalVariables'
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import type { Nullable } from '@/interfaces/utils'
import type { AnnouncementsResponse } from '@/interfaces/premium/Announcements'
import { mapActions } from 'pinia'
import { formatTime } from '@/helpers'
import ShrinkText from '../ShrinkText.vue'
import { usePremiumStore } from '@/store/pinia/premiumStore'

interface ComponentData {
  isLoading: boolean
}

export default defineComponent({
  components: {
    ShrinkText,
  },
  props: {
    announcement: {
      type: Object as PropType<Nullable<AnnouncementsResponse>>,
      default: () => null,
    },
  },
  data(): ComponentData {
    return {
      isLoading: false,
    }
  },
  computed: {
    showAnnouncement(): boolean {
      if (!this.announcement.showPercentage) return false

      return Math.random() < this.announcement.showPercentage
    },

    isAdventCalendar(): boolean {
      return this.announcement?.imgToShow === 'advent-calendar'
    },

    timer(): number {
      return this.announcement.marketingEnd
        ? new Date(this.announcement.marketingEnd).getTime() - Date.now()
        : 0
    },
  },
  methods: {
    formatTime,
    ...mapActions(usePremiumStore, ['loadRightboxes', 'loadAnnouncements']),
    async reloadAnnouncements(): Promise<void> {
      if (!this.isLoading) {
        this.isLoading = true
        // Pri prichode z klubovej mapy nepotrebujeme aktualizovat RB.
        await Promise.all([this.loadRightboxes(false), this.loadAnnouncements(true)])
        this.isLoading = false
      }
    },

    setBackgroundImage(): string {
      return `background-image: url(${pathImages}components/announcements/${this.announcement.imgToShow}.avif)`
    },
    goToAdvent(): void {
      this.$router.push({ name: this.$getWebView('AdventCalendarView') })
    },
  },
})
</script>

<style lang="scss" scoped>
.r-box {
  width: 15rem;
  height: 11.5625rem;
  pointer-events: all;
  @include background(null);

  &.announcement-advent {
    .r-box-text {
      height: 1.8rem;
      padding-left: 0.9rem;
      bottom: 2rem;
      overflow: hidden;
      white-space: nowrap;
      display: block;
      text-overflow: ellipsis;
    }
    .r-box-time {
      height: 1.9rem;
      width: 15rem;

      &-icon {
        width: 1em !important;
        height: 1em !important;
      }
    }
  }
}
</style>
